export const isBuilderPreview = () => {
	if (typeof window === 'undefined') return false;
	try {
		return (
			window.self !== window.top ||
			window.location.hostname.includes('builder.io') ||
			window.location.search.includes('builder.preview')
		);
	} catch {
		return true;
	}
};
